import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';

const AdminDashboard = () => {
    const [demandes, setDemandes] = useState([]);
    const [editingDemande, setEditingDemande] = useState(null);
    const [activeTab, setActiveTab] = useState('demandes');
    const navigate = useNavigate();

    const statuses = [
        'pas encore contacter',
        'déjà contacter',
        'en cours', 
        'conlue et non payé', 
        'conclu et payé', 
        'terminé', 
        'annulé'
    ];

    useEffect(() => {
        if (localStorage.getItem('isAdmin') !== 'true') {
            navigate('/admin/login');
        }
        fetchDemandes();
    }, [navigate]);

    const fetchDemandes = async () => {
        try {
            const res = await axios.get(`${API_URL}/demandes`);
            setDemandes(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        await axios.put(`${API_URL}/demandes/${id}`, { status: newStatus });
        fetchDemandes();
    };

    const handleDelete = async (id) => {
        if (window.confirm('Supprimer cette demande ?')) {
            await axios.delete(`${API_URL}/demandes/${id}`);
            fetchDemandes();
        }
    };

    const handleEditSave = async (e) => {
        e.preventDefault();
        try {
            await axios.put(`${API_URL}/demandes/${editingDemande.id}`, { 
                details: editingDemande.details 
            });
            setEditingDemande(null);
            fetchDemandes();
        } catch (err) {
            alert("Erreur lors de la sauvegarde");
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('isAdmin');
        navigate('/admin/login');
    };

    // Settings State
    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [settingsMsg, setSettingsMsg] = useState('');

    const handleUpdateCredentials = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.put(`${API_URL}/admin/update`, {
                oldUsername: 'admin',
                newUsername,
                newPassword
            });
            if (res.data.success) {
                setSettingsMsg('✅ Identifiants mis à jour avec succès !');
                setNewUsername('');
                setNewPassword('');
            }
        } catch (err) {
            setSettingsMsg('❌ Erreur lors de la mise à jour.');
        }
    };

    return (
        <div className="container py-4">
            <div className="row g-4">
                {/* Sidebar Menu */}
                <div className="col-lg-3">
                    <div className="card shadow-sm border-0 rounded-4 p-3 bg-white h-100">
                        <h5 className="fw-bold mb-4 px-3 mt-2">📊 Admin Panel</h5>
                        <div className="list-group list-group-flush">
                            <button 
                                className={`list-group-item list-group-item-action border-0 rounded-3 mb-2 d-flex align-items-center ${activeTab === 'demandes' ? 'active bg-warning text-dark fw-bold' : ''}`}
                                onClick={() => setActiveTab('demandes')}
                            >
                                <i className="bi bi-list-stars me-3"></i> Demandes
                            </button>
                            <button 
                                className={`list-group-item list-group-item-action border-0 rounded-3 mb-2 d-flex align-items-center ${activeTab === 'settings' ? 'active bg-warning text-dark fw-bold' : ''}`}
                                onClick={() => setActiveTab('settings')}
                            >
                                <i className="bi bi-gear-fill me-3"></i> Paramètres
                            </button>
                            <hr />
                            <button 
                                className="list-group-item list-group-item-action border-0 rounded-3 text-danger d-flex align-items-center"
                                onClick={handleLogout}
                            >
                                <i className="bi bi-box-arrow-right me-3"></i> Déconnexion
                            </button>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="col-lg-9">
                    {activeTab === 'demandes' ? (
                        <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-white">
                            <div className="card-header bg-white border-0 py-3">
                                <h5 className="fw-bold mb-0">Liste des demandes récentes</h5>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="bg-light text-muted small text-uppercase">
                                        <tr>
                                            <th className="p-3">📅</th>
                                            <th>👤 Client</th>
                                            <th>📞 Contact</th>
                                            <th>🚗 Type</th>
                                            <th>💰 Tarif</th>
                                            <th className="text-center">⚙️ Statut</th>
                                            <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {demandes.map((d) => (
                                            <tr key={d.id} className="border-bottom">
                                                <td className="p-3 small text-muted">{new Date(d.createdAt).toLocaleDateString()}</td>
                                                <td>
                                                    <div className="fw-bold text-dark">{d.details?.nom}</div>
                                                    <div className="x-small text-muted text-truncate" style={{ maxWidth: '150px' }}>
                                                        <i className="bi bi-geo-alt-fill me-1"></i> {d.details?.adresse}
                                                    </div>
                                                </td>
                                                <td>{d.details?.telephone}</td>
                                                <td><span className="badge rounded-pill bg-dark bg-opacity-10 text-dark border">{d.details?.typeChauffeur}</span></td>
                                                <td><span className="fw-bold text-success">{d.details?.tarif}</span></td>
                                                <td className="text-center">
                                                    <select 
                                                        className={`form-select form-select-sm border-0 bg-light fw-bold text-center ${d.status === 'annulé' ? 'text-danger' : 'text-primary'}`}
                                                        style={{ width: '150px', display: 'inline-block' }}
                                                        value={d.status}
                                                        onChange={(e) => handleStatusChange(d.id, e.target.value)}
                                                    >
                                                        {statuses.map(s => (
                                                            <option key={s} value={s}>{s}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                                <td className="text-center px-3">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary" 
                                                            onClick={() => setEditingDemande(d)}
                                                            title="Modifier"
                                                        >
                                                            <i className="bi bi-pencil"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger" 
                                                            onClick={() => handleDelete(d.id)}
                                                            title="Supprimer"
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div className="card shadow-sm border-0 rounded-4 p-4 bg-white">
                            <h5 className="fw-bold mb-4">Profil Administrateur</h5>
                            <p className="text-muted small mb-4">Mettez à jour vos identifiants pour plus de sécurité.</p>
                            
                            {settingsMsg && <div className="alert alert-info border-0 rounded-3 py-2 small">{settingsMsg}</div>}
                            
                            <form onSubmit={handleUpdateCredentials} className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label small fw-bold">Nom d'utilisateur</label>
                                    <input 
                                        type="text" 
                                        className="form-control py-2 shadow-none border-secondary border-opacity-25" 
                                        placeholder="Admin"
                                        value={newUsername} 
                                        onChange={(e) => setNewUsername(e.target.value)} 
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label small fw-bold">Nouveau mot de passe</label>
                                    <input 
                                        type="password" 
                                        className="form-control py-2 shadow-none border-secondary border-opacity-25" 
                                        placeholder="••••••••"
                                        value={newPassword} 
                                        onChange={(e) => setNewPassword(e.target.value)} 
                                    />
                                </div>
                                <div className="col-12 mt-4">
                                    <button type="submit" className="btn btn-warning py-2 px-4 fw-bold">
                                        Mettre à jour le profil
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>

            {/* Edit Modal (Pro Style) */}
            {editingDemande && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50" style={{ zIndex: 1050 }}>
                    <div className="card shadow-lg border-0 rounded-4 w-100" style={{ maxWidth: '450px' }}>
                        <div className="card-header bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                            <h5 className="fw-bold mb-0">Fiche Client</h5>
                            <button className="btn-close" onClick={() => setEditingDemande(null)}></button>
                        </div>
                        <div className="card-body p-4">
                            <form onSubmit={handleEditSave}>
                                <div className="mb-3">
                                    <label className="form-label x-small fw-bold text-uppercase text-muted">Nom Complet</label>
                                    <input type="text" className="form-control" value={editingDemande.details?.nom} onChange={(e) => setEditingDemande({...editingDemande, details: {...editingDemande.details, nom: e.target.value}})} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label x-small fw-bold text-uppercase text-muted">Téléphone</label>
                                    <input type="text" className="form-control" value={editingDemande.details?.telephone} onChange={(e) => setEditingDemande({...editingDemande, details: {...editingDemande.details, telephone: e.target.value}})} />
                                </div>
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label x-small fw-bold text-uppercase text-muted">Type</label>
                                        <input type="text" className="form-control" value={editingDemande.details?.typeChauffeur} onChange={(e) => setEditingDemande({...editingDemande, details: {...editingDemande.details, typeChauffeur: e.target.value}})} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label x-small fw-bold text-uppercase text-muted">Tarif/Pack</label>
                                        <input type="text" className="form-control" value={editingDemande.details?.tarif} onChange={(e) => setEditingDemande({...editingDemande, details: {...editingDemande.details, tarif: e.target.value}})} />
                                    </div>
                                </div>
                                <div className="mb-4">
                                    <label className="form-label x-small fw-bold text-uppercase text-muted">Adresse</label>
                                    <textarea className="form-control" rows="2" value={editingDemande.details?.adresse} onChange={(e) => setEditingDemande({...editingDemande, details: {...editingDemande.details, adresse: e.target.value}})} />
                                </div>
                                <div className="d-flex gap-2">
                                    <button type="submit" className="btn btn-warning flex-grow-1 fw-bold">Sauvegarder</button>
                                    <button type="button" className="btn btn-light" onClick={() => setEditingDemande(null)}>Annuler</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminDashboard;
